import { render, staticRenderFns } from "./viewMonitorPoint.vue?vue&type=template&id=35bb9cc5&scoped=true"
import script from "./viewMonitorPoint.vue?vue&type=script&lang=js"
export * from "./viewMonitorPoint.vue?vue&type=script&lang=js"
import style0 from "./viewMonitorPoint.vue?vue&type=style&index=0&id=35bb9cc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb9cc5",
  null
  
)

export default component.exports